module.exports = __webpack_public_path__ + "static/media/removeTile.bcde24aa.wav";